module.exports = __webpack_public_path__ + "img/background.96069f99.png";